import React from 'react';
import SelectEligibilityContainer from '../SelectEligibilityContainer';
import { birthSexOptions } from 'data/study/Eligibility/eligibilitySelectionOptions';


const name="eligibility.demographics.sex";

// Register all the required translation keys
const t = _ => {};
t('studyEligibilityComparitivePhrase.demographicsSex.include.option');
t('studyEligibilityComparitivePhrase.demographicsSex.exclude.option');
t('studyEligibilityComparitivePhrase.demographicsSex.undefined.option');

export default function StudyEligibilitySex({title}) {
    return (
        <SelectEligibilityContainer
            criteria="demographicsSex"
            name={name}
            options={birthSexOptions}
            title={title}
        />
    );
}